import React from 'react';

// The black AI mark. `square` is the panel-header badge (Hot Scam sub-tab
// panels); `pin` is the pentagon that hangs from a framed page's top border
// (the ribbon-only stub pages), mirroring the desktop panel's brand pin.
const AiMark = ({ variant = 'square', className = '' }) => {
  const isPin = variant === 'pin';
  return (
    <span
      className={`inline-flex items-center justify-center bg-black flex-shrink-0 ${
        isPin ? 'w-[76px] h-[92px] pb-5' : 'rounded-xl w-14 h-14'
      } ${className}`}
      style={isPin ? { clipPath: 'polygon(0 0, 100% 0, 100% 76%, 50% 100%, 0 76%)' } : undefined}
    >
      <img
        src="/mockup_images/marketing-remodel/about/aiLogoWhite.png"
        alt=""
        className={isPin ? 'h-9 w-auto' : 'h-8 w-auto'}
      />
    </span>
  );
};

export default AiMark;
